import { useCookies } from '@/components/composable/composable_cookie'
import type { components, paths } from '@/types/gateway_schema'
import createClient from 'openapi-fetch'
import { defineStore } from 'pinia'

type ReportingStoreState = {
  tenant_reportings: components['schemas']['ReportingDTO'][]
}

const client = createClient<paths>({
  baseUrl: '/gateway'
})

export const useReportingStore = defineStore('reporting', {
  state: (): ReportingStoreState => ({
    tenant_reportings: []
  }),
  getters: {
    getJWT: (_) => {
      const { getCookieValue } = useCookies()
      const cookie = getCookieValue('hv_jwt')
      return cookie
    },
    getTenantReporting: (state) => state.tenant_reportings
  },
  actions: {
    async fetchTenantReportings() {
      return client
        .GET('/api/tenant/reportings', {
          headers: { 'X-AUTH-TOKEN': this.getJWT.value }
        })
        .then((response) => {
          if (response.data) {
            this.tenant_reportings = response.data
          }
        })
    },
    async postReporting(reporting: components['schemas']['ReportingDTO']) {
      return client
        .POST(`/api/tenant/reportings`, {
          body: reporting,
          headers: { 'X-AUTH-TOKEN': this.getJWT.value }
        })
        .then((response) => {
          if (response.data) {
            this.tenant_reportings.push(response.data)
            alert(`Le reporting à été enregistré.`)
          }
        })
    },
    async deleteReporting(id: number) {
      return client
        .DELETE('/api/reporting/{id}', {
          headers: { 'X-AUTH-TOKEN': this.getJWT.value },
          params: { path: { id: id.toString() } }
        })
        .then(() => {
          const key = this.tenant_reportings.findIndex(() => id === id)
          this.tenant_reportings.splice(key, 1)
        })
    }
  }
})
